import { AssetRegistersContextMenu } from "../register-actions/register-actions.runtime"
import { RenameRegisterMenuItem } from "./rename-register-menu-item"

AssetRegistersContextMenu.plug(<RenameRegisterMenuItem priority={10} />)
